"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const react_2 = require("@osmosys/react");
const Inner_1 = require("./Inner");
const hooks_1 = require("../hooks");
exports.ContentImportPanelContentList = () => {
    const { contentFeed } = hooks_1.useContentImportPanelData();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_if_1.Switch, null,
            react_1.default.createElement(react_if_1.Case, { condition: !contentFeed },
                react_1.default.createElement(react_2.OsmosysUndesiredState, { level: "info", message: "Select a content feed" })),
            react_1.default.createElement(react_if_1.Case, { condition: !(contentFeed && contentFeed.contentMapping) },
                react_1.default.createElement(react_2.OsmosysUndesiredState, { level: "info", description: "Please add a mapping to the content feed", message: "This content feed has no associated content mapping" })),
            react_1.default.createElement(react_if_1.Default, null,
                react_1.default.createElement(Inner_1.ContentImportPanelContentListInner, null)))));
};
//# sourceMappingURL=index.js.map